import { globalActor } from "../../state/GlobalContextProvider";
import { useSelector } from "@xstate/react";
export default function StartScreen() {
  const state = useSelector(globalActor, (snapshot) => snapshot.value);
  return (
    <div className="Screen Start">
      <h1>
        <span className="visually-hidden">
          Miebo (perfluorohexyloctane ophtalmic solution)
        </span>
      </h1>
      {state === "start" ? (
        <button
          onClick={(_) => {
            globalActor.send({ type: "START" });
          }}
        >
          START
        </button>
      ) : (
        <div className="Loading"></div>
      )}
    </div>
  );
}
